import { render } from "./MasterCategory.vue?vue&type=template&id=aef7f558&scoped=true"
import script from "./MasterCategory.vue?vue&type=script&lang=js"
export * from "./MasterCategory.vue?vue&type=script&lang=js"

import "./MasterCategory.vue?vue&type=style&index=0&id=aef7f558&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef7f558"]])

export default __exports__